import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { StaffPreparationTaskDialogDeleteProps } from './staffPreparationTaskDialog'
import { useNotification } from '@/modules/context/NotificationContext'
import {
    DELETE_STAFF_PREPARATION_TASK,
    GET_STAFF_PREPARATION_TASKS_BY_DAYCARE
} from '@/modules/API/staff/staffPreparationTask'
import { useMutation } from '@apollo/client'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import Dialog from '@/components/_custom/Dialog/Dialog'
import styles from './staffPreparationTaskDialog.module.scss'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Delete, Close } from '@mui/icons-material'
import { useFutureWorkCountForStaffPreparationTask } from '@/hooks/useFutureWorkCountForStaffPreparationTask'

const DeleteStaffPreparationTaskDialog: FunctionComponent<StaffPreparationTaskDialogDeleteProps> = ({
    open,
    handleClose,
    daycare,
    staffPreparationTaskId,
    removeOneStaffPreparationTask
}: StaffPreparationTaskDialogDeleteProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const workCount: number = useFutureWorkCountForStaffPreparationTask(daycare.id, staffPreparationTaskId, !open)

    const [deleteOneStaffPreparationTask] = useMutation(DELETE_STAFF_PREPARATION_TASK, {
        variables: {
            daycareId: daycare.id,
            staffPreparationTaskId: staffPreparationTaskId
        },
        refetchQueries: [{ query: GET_STAFF_PREPARATION_TASKS_BY_DAYCARE, variables: { daycareId: daycare.id } }],
        onCompleted: () => {
            removeOneStaffPreparationTask(staffPreparationTaskId)
            handleClose()
            showNotificationSuccess(t('staffPreparationTaskDeleted'))
        },
        onError: () => {
            showNotificationError(t('errorDeletedStaffPreparationTask'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('confirmDeleteStaffPreparationTask')} />
            <DialogBody className={styles.DialogBody}>
                {workCount > 0 && <p className={styles.Text}>{t('taskInFutureWorks', { count: workCount })}</p>}
                <p className={styles.Text}>{t('areYouSureDeleteStaffPreparationTask')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type='custom'
                        customText={t('yes')}
                        customIcon={<Delete />}
                        className={styles.Button}
                        onClick={() => deleteOneStaffPreparationTask()}
                    />
                    <ButtonTextIcon
                        type='custom'
                        customIcon={<Close />}
                        customText={t('no')}
                        className={styles.Button}
                        onClick={handleClose}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default DeleteStaffPreparationTaskDialog
